import React from 'react';

const Chip = ({ label, onRemove, removable = false }) => {
  return (
    <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-50 text-blue-500 font-medium">
      <span>{label}</span>
      {removable && (
        <button
          type="button"
          onClick={onRemove}
          className="ml-2 text-blue-500 focus:outline-none"
        >
          &times;
        </button>
      )}
    </div>
  );
};

export default Chip;
